import React from "react";
import { Link, TablePagination, TableSortLabel } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  getFormattedHeaders,
  getFormattedValues
} from "../../../utils/formatData";

class PopupTable extends React.Component {
  constructor(props) {
    super(props);
  }

  /** set / update page value */
  handleChangePage = (event, newPage) => {
    this.props.updateRowCount(newPage, this.props.rowsPerPagination);
  };

  /** update row change values */
  handleChangeRowsPerPage = event => {
    this.props.updateRowCount(0, parseInt(event.target.value, 10));
  };

  render() {
    const {
      data,
      rowsPerPagination,
      pageNo,
      rowsPerPageOptions,
      order,
      orderBy,
      columns
    } = this.props;

    return (
      <>
        {
          <TableContainer component={Paper}>
            <Table className={"tenant-list-table popup-table"}>
              <TableHead>
                <TableRow className={"blue-custom-title"}>
                  {columns.map((col, index) => {
                    return (
                      <TableCell key={index}>
                        {col.isSort === true ? (
                          <TableSortLabel
                            active={orderBy === col.key}
                            direction={orderBy === col.key ? order : "asc"}
                            onClick={() => {
                              this.props.sortBy(col.key);
                            }}
                            style={{
                              color: "white"
                            }}
                          >
                            {getFormattedHeaders(col.name, col.dataFormat)}
                          </TableSortLabel>
                        ) : (
                          getFormattedHeaders(col.name, col.dataFormat)
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data.length > 0 ? (
                  (
                    (rowsPerPagination > 0
                      ? data.slice(
                          pageNo * rowsPerPagination,
                          pageNo * rowsPerPagination + rowsPerPagination
                        )
                      : data) || []
                  ).map((data, index) => (
                    <TableRow>
                      {columns.map((col, ind) => {
                        return (
                          <TableCell
                            key={
                              index +
                              ind +
                              data.CategoryId +
                              data.IncidentId +
                              data.SubCategoryId
                            }
                          >
                            {col.isLink === true ? (
                              <Link
                                style={{ cursor: "pointer" }}
                                onClick={event => {
                                  this.props.onCountClick(
                                    event,
                                    data[col.countFilterKey]
                                  );
                                }}
                              >
                                {getFormattedValues(
                                  data[col.key],
                                  col.dataFormat,
                                  true
                                )}
                              </Link>
                            ) : (
                              getFormattedValues(
                                data[col.key],
                                col.dataFormat,
                                true
                              )
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align={"center"}>{"No data available"}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {data && data.length > 0 && (
              <div className={"paginationContainer"}>
                <TablePagination
                  rowsPerPageOptions={rowsPerPageOptions}
                  component={"div"}
                  count={data?.length}
                  rowsPerPage={rowsPerPagination}
                  page={pageNo}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </div>
            )}
          </TableContainer>
        }
      </>
    );
  }
}

export default PopupTable;
